// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__o9CP2","type":"styles_type__SsFpl","choices":"styles_choices__3aqkw"};